import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [

    // appContainer
    {
        path: '/',
        component: () => import('../containers/AppContainer'),
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import('../views/Home')
            },

            {
                path: '/profile',
                name: 'profile',
                component: () => import('../views/Profile.vue')
            },


            {
                path: '/loanreport',
                name: 'loanreport',
                component: () => import('../views/LoanReport.vue')
            },
            {
                path: '/depositreport',
                name: 'depositreport',
                component: () => import('../views/DepositReport.vue')
            },
            {
                path: '/newrequest',
                name: 'newrequest',
                component: () => import('../views/Request/NewRequest.vue')
            },
            {
                path: '/requestreport',
                name: 'requestreport',
                component: () => import('../views/RequestReport.vue')
            },
            {
                path: '/newpayment',
                name: 'newpayment',
                component: () => import('../views/NewPayment.vue')
            },
            {
                path: '/paymentreport',
                name: 'paymentreport',
                component: () => import('../views/PaymentReport.vue')
            },
            {
                path: '/messages',
                name: 'messages',
                component: () => import('../views/Messages.vue')
            },
            {
                path: '/readmessage',
                name: 'readmessage',
                component: () => import('../views/ReadMessages.vue')
            },
            {
                path: '/settings',
                name: 'settings',
                component: () => import('../views/Settings.vue')
            },
            {
                path: '/',
                name: 'login',
                component: () => import('../views/Login.vue')
            },

            ///----------------- TAX SERVICE
            {
                path: '/register',
                name: 'register',
                component: () => import('../views/TaxService/Register.vue')
            },
            {
                path: '/sellFactors',
                name: 'sellFactors',
                component: () => import('../views/TaxService/SellFactors.vue')
            },
            {
                path: '/sentFactors',
                name: 'sentFactors',
                component: () => import('../views/TaxService/SentFactors.vue')
            },
            {
                path: '/successFactors',
                name: 'successFactors',
                component: () => import('../views/TaxService/SuccessFactors.vue')
            },
            ///----------------- TAX SERVICE

        ]
    },
    // matchContainer
    // {
    //     path: '/login',
    //     component: () => import('../containers/MatchContainer'),
    //     children: [
    //         //         {
    //         //             path: '/home',
    //         //             name: 'home',
    //         //             component: () => import('../views/Home')
    //         //         },
    //         //         {
    //         //             path: '/',
    //         //             name: 'home',
    //         //             component: () => import('../views/Home')
    //         //         },
    //         //         {
    //         //             path: '',
    //         //             name: 'home',
    //         //             component: () => import('../views/Home')
    //         //         },
    //         {
    //             path: '/login',
    //             name: 'login',
    //             component: () => import('../views/Login.vue')
    //         },
    //         //         {
    //         //
    //         //             path: '/billing/loanreport',
    //         //             name: 'loanreport',
    //         //             component: () => import('../views/Billing/LoanReport.vue')
    //         //         },
    //         //         {
    //         //             path: '/billing/depositreport',
    //         //             name: 'depositreport',
    //         //             component: () => import('../views/Billing/DepositReport.vue')
    //         //         },
    //         //         {
    //         //             path: '/request/newrequest',
    //         //             name: 'newrequest',
    //         //             component: () => import('../views/Request/NewRequest.vue')
    //         //         },
    //         //         {
    //         //             path: '/request/requestreport',
    //         //             name: 'requestreport',
    //         //             component: () => import('../views/Request/RequestReport.vue')
    //         //         },
    //         //         {
    //         //             path: '/payment/newpayment',
    //         //             name: 'newpayment',
    //         //             component: () => import('../views/Payment/NewPayment.vue')
    //         //         },
    //         //         {
    //         //             path: '/payment/paymentreport',
    //         //             name: 'paymentreport',
    //         //             component: () => import('../views/Payment/PaymentReport.vue')
    //         //
    //         //         },
    //         //         {
    //         //             path: '/myRequst',
    //         //             name: 'myRequst',
    //         //             component: () => import('../views/UserPanel/MyRequest.vue')
    //         //         },
    //         //         {
    //         //             path: '/detailItem',
    //         //             name: 'detailItem',
    //         //             component: () => import('../views/UserPanel/DetailItem.vue')
    //         //         },
    //         //         // {
    //         //         //     path: '/billing/clubHouse',
    //         //         //     name: 'clubHouse',
    //         //         //     component: () => import('../views/Billing/ClubHouse.vue')
    //         //         // },
    //         //
    //     ]
    // },
    // adminContainer
    // {
    //     path: '/admin',
    //     component: () => import('../containers/AdminContainer'),
    //     children: [
    //         {
    //             path: '/mainItems',
    //             name: 'mainItems',
    //             component: () => import('../views/Admin/MainItems.vue')
    //         },
    //         {
    //             path: '/subItems',
    //             name: 'subItems',
    //             component: () => import('../views/Admin/SubItems.vue')
    //         },
    //
    //         // Definitions
    //         // {
    //         //     path: '/admin/fields',
    //         //     name: 'adminFields',
    //         //     component: () => import('../views/Admin/Definitions/Fields')
    //         // },
    //         //
    //     ]
    // },
    // webContainer
    // {
    //     path: '/web',
    //     component: () => import('../containers/WebContainer'),
    //     children: [
    //         {
    //             path: '/mainpage',
    //             name: 'mainpage',
    //             component: () => import('../views/WebView/Mainpage.vue')
    //         },
    //         // {
    //         //     path: '/subItems',
    //         //     name: 'subItems',
    //         //     component: () => import('../views/Admin/SubItems.vue')
    //         // },
    //
    //         // Definitions
    //         // {
    //         //     path: '/admin/fields',
    //         //     name: 'adminFields',
    //         //     component: () => import('../views/Admin/Definitions/Fields')
    //         // },
    //         //
    //     ]
    // }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
